module.exports = __webpack_public_path__ + "img/IMG-20200809-WA0011.505d291d.jpg";